import React, {useMemo, useState} from 'react';
import Popup, {showPopup} from '../popup/popup';
import './_aboutOrganizersBlock.scss';

const OrganizerItem = ({organizer, needLongText, callback}) => useMemo(() => {
    return (
        <>
            <div className='row'>
                <a href={organizer.organizers_link} target='_blank' rel='noreferrer noopener'
                   className='col-lg-12 organizerAvatarBlock'>
                    <img className='companyLogoImage' src={organizer.logo} alt={`${organizer.title}-logo`}/>
                    <span className='companyName' dangerouslySetInnerHTML={{__html: organizer.title}}/>
                </a>
                <div className='col-lg-12 organizersInfo'>
                    <h5 dangerouslySetInnerHTML={{__html: organizer.text}}/>
                    <p dangerouslySetInnerHTML={{__html: needLongText ? organizer.long_text : organizer.short_text}}/>
                </div>
            </div>
            {callback &&
                <p className='readMoreBtn' onClick={(e) => callback(e, organizer.uniq)}>Read More</p>
            }
        </>
    );
}, [organizer, needLongText, callback]);

function AboutOrganizersBlock({organizerData, title}) {
    console.log(organizerData);
    const [organizerTemplate, setOrganizerTemplate] = useState(null);

    function openOrganizerPopup(e, organizerUniq) {
        // navigator && navigator.clipboard && navigator.clipboard.writeText("Hi bro what's up");

        const organizer = organizerData.find(item => item.uniq === organizerUniq);
        setOrganizerTemplate(<OrganizerItem organizer={organizer} needLongText callback={null}/>);
        showPopup('.aboutPopupContainer');
    }

    return (
        <>
            <div className='aboutPopupContainer'>
                <Popup htmlTemplate={organizerTemplate} parentClass='.aboutPopupContainer'/>
            </div>

            <section className='organizersBlock organizersBlockAbout leftPadding rightPadding' id='organizers'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-md-12 mb-xl-5 pr-0'>
                            <h3 className='text-xl-right organizerTitleText'>
                                {title}
                            </h3>
                        </div>
                        <div className='organizersMainInfo'>
                            {organizerData?.map((organizer, i) =>
                                <div key={i} className={`col-lg-12 withBorders pl-0 mt-0`}>
                                    <OrganizerItem organizer={organizer} callback={openOrganizerPopup}/>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default AboutOrganizersBlock;
